const SearchIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.739"
        height="16.121"
        viewBox="0 0 15.739 16.121"
        fill="currentColor"
        stroke="currentColor"
        {...props}
    >
        <g id="search_boundaryless_v1_2X" data-name="search_boundaryless_v1 2X" transform="translate(1 1)">
            <g id="Group_11902" data-name="Group 11902" transform="translate(0.264 0.131)">
                <g id="Group_11901" data-name="Group 11901" transform="translate(0)">
                    <g id="Group_11899" data-name="Group 11899" transform="translate(0 0)">
                        <g id="Group_11900" data-name="Group 11900" transform="translate(0 0)">
                            <g
                                id="Ellipse_242"
                                data-name="Ellipse 242"
                                transform="translate(-0.264 -0.131)"
                                fill="none"
                            >
                                <circle cx="5" cy="5" r="5" stroke="none" />
                                <circle cx="5" cy="5" r="5.5" fill="none" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <path
                id="Rectangle_2779"
                data-name="Rectangle 2779"
                d="M0,0H4.044A1.348,1.348,0,0,1,5.392,1.348v0A1.348,1.348,0,0,1,4.044,2.7H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
                transform="translate(10.927 9.402) rotate(45)"
            />
        </g>
    </svg>
);

export default SearchIcon;
